import { render, staticRenderFns } from "./viewReservitionList2.vue?vue&type=template&id=fc442ef0&scoped=true&"
import script from "./viewReservitionList2.vue?vue&type=script&lang=js&"
export * from "./viewReservitionList2.vue?vue&type=script&lang=js&"
import style0 from "./viewReservitionList2.vue?vue&type=style&index=0&id=fc442ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc442ef0",
  null
  
)

component.options.__file = "viewReservitionList2.vue"
export default component.exports